<template>
  <el-popover ref="popover"
              class="data-grid-bubble"
              :placement="placement"
              trigger="manual"
              v-model="isShow"
              v-bind="$attrs"
              v-on="bubbleListeners">
    <span slot="reference">
      <slot name="reference"></slot>
    </span>
    <div ref="render">
      <slot v-if="rendered"></slot>
    </div>
  </el-popover>
</template>

<script>
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
import layoutConstants from '../../../constants/layoutConstants'
import PopperBus from '../../../mixins/popper/bus'
import PopperDecorator from '../../../mixins/popper/decorator'
let bubbleStore = {
  current: null
}

export default {
  name: 'DataGridBubble',
  mixins: [PopperBus, PopperDecorator],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },
  provide () {
    return {
      $popper: this
    }
  },
  data () {
    return {
      isShow: false,
      rendered: false
    }
  },
  computed: {
    bubbleListeners () {
      return this.$extend(this.$listeners, {
        show: this.openEvent,
        'after-enter': this.openedEvent,
        hide: this.closeEvent,
        'after-leave': this.closedEvent
      })
    }
  },
  methods: {
    initialBubble () {
      if (this.visible && !this.rendered) {
        this.rendered = true
      }
      this.isShow = this.visible
    },
    renderBubbleChanged () {
      let popover = this.$refs['popover']
      if (popover) {
        popover.updatePopper()
      }
    },
    handleLayoutClick () {
      this.isShow = false
    },
    installEvent () {
      this.$bus.$on(layoutConstants.event.LAYOUT_CLICK, this.handleLayoutClick)
    },
    installResizeEvent () {
      let render = this.$refs['render']
      if (render) {
        addResizeListener(render, this.renderBubbleChanged)
      }
    },
    uninstallEvent () {
      this.$bus.$off(layoutConstants.event.LAYOUT_CLICK, this.handleLayoutClick)
      if (this.rendered) {
        let render = this.$refs['render']
        if (render) {
          removeResizeListener(render, this.renderBubbleChanged)
        }
      }
    }
  },
  beforeMount () {
    this.installEvent()
  },
  mounted () {
    this.initialBubble()
  },
  beforeDestroy () {
    this.uninstallEvent()
  },
  watch: {
    visible: function (val) {
      if (val && !this.rendered) {
        this.initialBubble()
      } else {
        this.isShow = val
      }
    },
    isShow: function (val) {
      if (val) {
        if (bubbleStore.current !== this) {
          if (bubbleStore.current) {
            bubbleStore.current.isShow = false
          }
          bubbleStore.current = this
        }
      } else {
        if (bubbleStore.current === this) {
          bubbleStore.current = null
        }
      }
      this.$emit('update:visible', val)
    },
    rendered: function (val) {
      if (val) {
        this.$nextTick(() => this.installResizeEvent())
      }
    }
  }
}
</script>

<style lang="scss">
  .data-grid-bubble {
    .el-popover__reference {
      display: inline-block!important;
      outline: none!important;
    }
  }
</style>
